import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, AlertCircle } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full bg-[#050505] py-24 px-4 relative overflow-hidden" data-id="element-644">
      {/* Background Gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505] pointer-events-none" data-id="element-645"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-646">
        {/* TRANSITION */}
        <div className="text-center mb-24 space-y-8" data-id="element-647">
          <h2 className="font-serif text-3xl md:text-4xl text-[#f5f0e8]" data-id="element-648">
            ¿Qué se hace? <br data-id="element-649" />
            <span className="text-[#d4af37]" data-id="element-650">
              Ser más mecánico donde eres más vulnerable.
            </span>
          </h2>

          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-[#8a8578] italic" data-id="element-651">
            <span className="border-b border-red-900/50 pb-1" data-id="element-652">
              "esta vez es diferente"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-653">
              "solo un trade más"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-654">
              "si recupero, cierro"
            </span>
          </div>

          <p className="text-2xl md:text-3xl font-serif text-[#d4af37] pt-8" data-id="element-655">
            Tu mente no necesita razón. <br data-id="element-656" />
            Solo necesita alivio.
          </p>
        </div>

        {/* PRODUCT SHOWCASE */}
        <div className="bg-[#080808] border border-[#222] rounded-2xl p-8 md:p-12 shadow-2xl shadow-black/50" data-id="element-657">
          <div className="text-center mb-12" data-id="element-658">
            <span className="text-[#d4af37] text-sm font-bold tracking-[0.2em] uppercase" data-id="element-659">
              Presentando
            </span>
            <h3 className="font-serif text-3xl md:text-5xl text-[#f5f0e8] mt-4 mb-4 leading-tight" data-id="element-660">
              El Protocolo PP-7 <br data-id="element-661" />
              <span className="text-[#d4af37] text-2xl md:text-4xl" data-id="element-662">
                (Procedimiento de Intervención en Tiempo Real)
              </span>
            </h3>
            <p className="text-[#8a8578] max-w-xl mx-auto" data-id="element-663">
              El sistema mecánico que te obliga a mantenerte plano cuando tus
              emociones intentan tomar el control de tu cuenta.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-664">
            <div className="relative" data-id="element-665">
              <div className="absolute inset-0 bg-[#d4af37]/10 blur-[40px] rounded-full" data-id="element-666"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hQPLBsfQFPrPVRzJP5VmAi/Imagen_final_del_producto.png" alt="Trading en Paz Product" className="relative z-10 w-full rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" data-id="element-667" />
            </div>

            <div className="space-y-8" data-id="element-668">
              <div className="space-y-2" data-id="element-669">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-670">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-671">
                    1
                  </span>
                  Protocolo Plano (PP-7)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-672">
                  Herramienta de intervención en tiempo real. Corta el sabotaje
                  antes de que crezca.
                </p>
              </div>

              <div className="space-y-2" data-id="element-673">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-674">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-675">
                    2
                  </span>
                  Reprogramación Identitaria (RI-3)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-676">
                  Sistema de identidad para que el sabotaje aparezca cada vez
                  menos.
                </p>
              </div>
            </div>
          </div>

          {/* DEEP DIVE: PP-7 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-677">
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-678">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-679">
                <AlertCircle size={20} data-id="element-680" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-681">
                  PP-7: LOS GATILLOS
                </h4>
              </div>
              <p className="text-[#f5f0e8] text-sm mb-4" data-id="element-682">
                Si aparece este gatillo → aplico esta respuesta.
              </p>
              <ul className="space-y-2 text-sm text-[#8a8578]" data-id="element-683">
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-684">
                  <span data-id="element-685">FOMO</span>
                  <span className="text-[#f5f0e8]" data-id="element-686">
                    Pausa 90s + regla "2 velas"
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-687">
                  <span data-id="element-688">Pérdida reciente</span>
                  <span className="text-[#f5f0e8]" data-id="element-689">
                    Cierre 3 min + respiración
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-690">
                  <span data-id="element-691">Euforia</span>
                  <span className="text-[#f5f0e8]" data-id="element-692">Reduzco tamaño al 70%</span>
                </li>
              </ul>
            </div>

            {/* DEEP DIVE: RI-3 */}
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-693">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-694">
                <Check size={20} data-id="element-695" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-696">
                  RI-3: IDENTIDAD
                </h4>
              </div>
              <div className="space-y-4" data-id="element-697">
                <div data-id="element-698">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-699">
                    A) Lenguaje
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-700">
                    "No reparo dolor con clicks."
                  </p>
                </div>
                <div data-id="element-701">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-702">
                    B) Ritual
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-703">
                    Semáforo + Checklist (60 seg)
                  </p>
                </div>
                <div data-id="element-704">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-705">
                    C) Evidencia
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-706">
                    Diario mínimo de obediencia
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center border-t border-[#222] pt-12" data-id="element-707">
            <p className="font-serif text-xl md:text-2xl text-[#f5f0e8] leading-relaxed" data-id="element-708">
              "Trading en paz no significa no sentir. <br data-id="element-709" />
              <span className="text-[#d4af37]" data-id="element-710">
                Significa no obedecerle al sentimiento.
              </span>
              "
            </p>
          </div>
        </div>
      </div>
    </section>;
}